module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-hairmake-d6e72f2628620aa065e7eecedc6b0241.jpg";